import React from 'react'
import PropTypes from 'prop-types'
import Loader from 'components/Loader'
import './style.css'


const ScreenLoader = (props) => {
    if (!props.isLoading) {
        return null
    }

    return (
        <div className='screen-loader'>
            <div className='loader-box'>
                <Loader />
            </div>
        </div>
    )
}

ScreenLoader.propTypes = {
    isLoading: PropTypes.bool
}

ScreenLoader.defaultProps = {
    isLoading: false
}

export default ScreenLoader
